





















































import Vue from 'vue';
import { ICategoryShowObject } from '../../../../../shared/types';
import api from '../../../api';

interface IData {
  shows: ICategoryShowObject[]
}

interface IMethods {
  goToCategory: () => void;
}

interface IComputed {
  images: string[];
  showOverlay: boolean;
}

interface IProps {
  id: number;
  created: number;
  description: string;
  imageUrl: string;
  name: string;
  userId: number;
  username: string;
  padding: boolean;add: boolean;
  relevantId: number;
}

export default Vue.extend<IData, IMethods, IComputed, IProps>({
  name: 'CategoryCardItem',

  props: {
    id: {
      type: Number,
      default: 0,
    },

    created: {
      type: Number,
      default: 0,
    },

    description: {
      type: String,
      default: '',
    },

    imageUrl: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      required: true,
    },

    userId: {
      type: Number,
      default: -1,
    },

    username: {
      type: String,
      default: 'Unknown',
    },

    padding: {
      type: Boolean,
      default: false,
    },

    add: {
      type: Boolean,
      default: false,
    },

    relevantId: {
      type: Number,
      default: -1,
    },
  },

  data: () => ({
    shows: [] as ICategoryShowObject[],
  }),

  async created() {
    this.shows = await api.category.getShows(this.id);
  },

  methods: {
    goToCategory() {
      if (this.add) {
        this.$emit('add', this.id);
      } else {
        this.$router.push(`/category/${this.id}`);
      }
    },
  },

  computed: {
    images() {
      if (this.shows.length < 4) {
        const images = [];

        for (let i = 0; i < 4; i += 1) {
          if (this.shows[i % this.shows.length] && 'posterUrl' in this.shows[i % this.shows.length]) {
            images.push(this.shows[i % this.shows.length].posterUrl);
          }
        }

        return images;
      }
      return this.shows.map((show) => show.posterUrl || '');
    },

    showOverlay() {
      return this.add && !(this.shows.map((show) => show.id).includes(this.relevantId));
    },
  },
});
